module.exports = __webpack_public_path__ + "icons.component.svg";